import { hasValue } from 'src/packages/utils/has-value';

import type { TEnableIfRule } from '../mappers';

export const handleEnableIfRule = (record: Record<string, unknown>, rule: TEnableIfRule): { isDisabled: boolean } => {
  let isDisabled = false;

  for (const cond of rule.ruleView) {
    if (isDisabled) {
      break;
    }

    const managValue = record[cond.control];

    if (cond.value === '!null') {
      isDisabled = !hasValue(managValue);
      continue;
    }

    isDisabled = managValue !== cond.value;
  }

  return { isDisabled };
};
